import styled from 'styled-components'
import ContentLoader from 'react-content-loader'

export const Content = styled(ContentLoader)`
  /* flex-grow: 1;
  display: flex; */
  /* min-width: 460px; */
  /* display: flex;
  flex-flow: 1;
  flex-grow: 1;
  flex-shrink: 1; */
`
